window.VH = window.VH === undefined ? {} : window.VH;

VH.PageUpdater = {
    timeout : 180000,
    href : null,

    updatePage : function updatePage()
    {
        let _t = VH.PageUpdater;
        setTimeout( function() {
            document.location.href = _t.href;
            _t.updatePage();
        }, _t.timeout);
    },

    init : function init(timeout, href)
    {
        let _t = VH.PageUpdater;
        _t.timeout = timeout === undefined ? _t.timeout : timeout;
        _t.href = href;
        if (_t.href !== undefined && _t.href !== null && typeof _t.href === 'string' && _t.href.length > 0) {
            _t.updatePage();
        }
    }
};
